module.exports = __webpack_public_path__ + "21b675a92a55c6c283fd1f73dfc914af.png";